<template>
  <div class="animated fadeInUp" id="vendors">
    <div class="section d-none d-md-block">     
      <h3 class="text-bold">Your Vendors</h3>
      <h4>List of Vendors</h4>
      <div class="has-text-centered">
          <div class="has-text-centered">
            <div class="pt-20 pb-50">
              <div class="">
                <div class="hr-content">

                  <div class="row mb-10 pb-2 d-flex align-items-center">
                    <!-- <div class="col-6 text-left">
                      <b-button class="px-5" pill variant="primary">Request For Vendor</b-button>
                    </div> -->

                    <div class="col-6 position-relative">
                      <b-form-group class="mb-0">
                        <b-input-group size="sm">
                          <b-form-input
                            id="filter-input"
                            v-model="masterTableProps.filter"
                            type="search"
                            placeholder="Search For Vendors"
                            class="rounded-pill"
                          ></b-form-input>
                        </b-input-group>
                      </b-form-group>
                      <i class="fas fa-search position-absolute"></i>
                    </div>
                  </div>

                  <div class="bg-white pb-50 the-table">
                    <b-table 
                      ref="table"
                      id="my-table" 
                      hover 
                      head-variant="dark"
                      :items="payerVendors" 
                      :fields="masterTableProps.fields" 
                      :filter="masterTableProps.filter"
                      :per-page="masterTableProps.resultsPerPage"
                      :current-page="masterTableProps.currentPage"
                      :sort-by.sync="masterTableProps.sortBy"
                      :sort-direction="masterTableProps.sortDirection"
                      :sort-desc.sync="masterTableProps.sortDesc"
                      :filter-included-fields="masterFilterProps.filterIncludedFields"
                      show-empty
                      :busy="payerVendorsIsReady"
                    >
                      <template #empty>
                        <empty-table></empty-table>
                      </template>
                      <template #table-busy>
                        <div class="d-flex justify-content-center">
                          <spinner></spinner>
                        </div>
                      </template>
                      <template #cell(details)="data">
                        <router-link :to="'/vendors/' + data.item.id">
                          <b-button pill variant="primary" class="table-btn px-5 py-1">Payment History</b-button>
                        </router-link>
                      </template>
                      <template #cell(request)="data">
                        <router-link :to="'/vendors/pay/' + data.item.id">
                          <b-button pill variant="success" class="table-btn px-5 py-1">Pay Vendor</b-button>
                        </router-link>
                      </template>
                    </b-table>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
    <div class="section d-block d-md-none mt-3">

      <h3 class="text-bold text-primary text-center">
        <svg width="41" height="42" viewBox="0 0 41 30" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M28.1429 9.85714C30.87 9.85714 33.055 7.65571 33.055 4.92857C33.055 2.20143 30.87 0 28.1429 0C25.4157 0 23.2143 2.20143 23.2143 4.92857C23.2143 7.65571 25.4157 9.85714 28.1429 9.85714ZM15 9.85714C17.7271 9.85714 19.9121 7.65571 19.9121 4.92857C19.9121 2.20143 17.7271 0 15 0C12.2729 0 10.0714 2.20143 10.0714 4.92857C10.0714 7.65571 12.2729 9.85714 15 9.85714ZM15 13.1429C11.1721 13.1429 3.5 15.065 3.5 18.8929V23H26.5V18.8929C26.5 15.065 18.8279 13.1429 15 13.1429ZM28.1429 13.1429C27.6664 13.1429 27.1243 13.1757 26.5493 13.225C28.455 14.605 29.7857 16.4614 29.7857 18.8929V23H39.6429V18.8929C39.6429 15.065 31.9707 13.1429 28.1429 13.1429Z" fill="#0070BA"/>
        </svg>
         Your Vendors
      </h3>
      
      <!-- <router-link :to="'/customers/request-payment/'" class="w-sm-100 mb-xs-1 mr-sm-1 mr-xs-0"> -->
      <!-- TODO: add search here -->
        <!-- <button class="border-2 py-2 d-flex align-items-center justify-content-center btn bg-none border-primary rounded-pill w-100">
          <div class="d-flex align-items-center">
            <i class="fas fa-plus bg-primary p-2 mr-3 rounded-pill text-white"></i>
            <h3 class="my-0 text-primary">Request Vendor</h3>
          </div>
        </button> -->
      <!-- </router-link> -->
      <!-- TODO: change from boxes to mobile table style -->
      <mobile-vendors
        xtransactions="payerReceivedTransactions"
        :transactions="payerVendors"
        :loading="payerReceivedTransactionsIsBusy"
        :limit="10"
        :hasRoute="true"
        :routerLink="mobileTransactionsConfig.router_link"
        :filter="mobileTransactionsConfig.filter_mobile"
        :type="mobileTransactionsConfig.table_type"
        :search="mobileTransactionsConfig.search"
      />

      <!-- <b-skeleton-wrapper :loading="loading" class="d-md-none pt-5">
        <template #loading>
          <p>
            <b-skeleton></b-skeleton>
            <b-skeleton width="25%"></b-skeleton>
            <b-skeleton></b-skeleton>
          </p>
          <p>
            <b-skeleton></b-skeleton>
            <b-skeleton width="35%"></b-skeleton>
            <b-skeleton></b-skeleton>
          </p>
          <p>
            <b-skeleton></b-skeleton>
            <b-skeleton width="55%"></b-skeleton>
            <b-skeleton></b-skeleton>
          </p>
          <p>
            <b-skeleton></b-skeleton>
            <b-skeleton width="65%"></b-skeleton>
            <b-skeleton></b-skeleton>
          </p>
          <p>
            <b-skeleton></b-skeleton>
            <b-skeleton width="75%"></b-skeleton>
            <b-skeleton></b-skeleton>
          </p>
          <p>
            <b-skeleton></b-skeleton>
            <b-skeleton width="85%"></b-skeleton>
            <b-skeleton></b-skeleton>
          </p>
          <p>
            <b-skeleton></b-skeleton>
            <b-skeleton width="95%"></b-skeleton>
            <b-skeleton></b-skeleton>
          </p>
        </template>
        <div class="row mt-2">
          <div v-for="(vendor, index) in payerVendors" :key="index" class="col-6 p-4">
            <router-link :to="'/vendors/pay/' + vendor.id">
              <div class="border rounded p-2 py-5">
                <div class="d-flex justify-content-center">
                  <svg style="width: 30%" aria-hidden="true" data-prefix="fal" data-icon="user-circle" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496 512" class="svg-inline--fa fa-user-circle fa-w-16 fa-5x"><path fill="currentColor" d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm128 421.6c-35.9 26.5-80.1 42.4-128 42.4s-92.1-15.9-128-42.4V416c0-35.3 28.7-64 64-64 11.1 0 27.5 11.4 64 11.4 36.6 0 52.8-11.4 64-11.4 35.3 0 64 28.7 64 64v13.6zm30.6-27.5c-6.8-46.4-46.3-82.1-94.6-82.1-20.5 0-30.4 11.4-64 11.4S204.6 320 184 320c-48.3 0-87.8 35.7-94.6 82.1C53.9 363.6 32 312.4 32 256c0-119.1 96.9-216 216-216s216 96.9 216 216c0 56.4-21.9 107.6-57.4 146.1zM248 120c-48.6 0-88 39.4-88 88s39.4 88 88 88 88-39.4 88-88-39.4-88-88-88zm0 144c-30.9 0-56-25.1-56-56s25.1-56 56-56 56 25.1 56 56-25.1 56-56 56z"/></svg>
                </div>
                <div class="d-flex justify-content-center text-center mt-3">
                  {{ vendor.name }}
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </b-skeleton-wrapper> -->

      <FooterSpacing></FooterSpacing>
    </div>
  </div>
</template>
<script>
import TransactionAPI from '../api/transactions_api';
import store from '../store';
import { tableMixin } from '../utils/table.mixin';
import spinner from '../utils/Spinner';
import EmptyTable from '../utils/empty-table.vue';
import FooterSpacing from '../components/FooterMobile.vue';
import MobileVendors from '../components/MobileVendors.vue';

export default {
  mixins: [
    tableMixin
  ],
  components: {
    spinner,
    EmptyTable,
    FooterSpacing,
    MobileVendors
  },
  data() {
    return {
      loading: false,
      authenticated: '',
      loggedInUser: {},
      masterTableProps: {
        fields: [
          {
            key: 'name',
            sortable: true,
            label: 'Vendor'
          },
          {
            key: 'address',
            sortable: false,
            label: 'Location'
          },
          {
            key: 'details',
            sortable: false,
            label: 'Details'
          },
          {
            key: 'request',
            sortable: false,
            label: 'Request'
          }
        ],
        filter: null,
        filterIncludedFields: ['name'],
        resultsPerPage: 10,
        currentPage: 1,
        sortBy: 'created_at',
        sortDirection: 'asc',
        totalRows: 1,
        sortDesc: true
      },
      mobileTransactionsConfig: {
        filter_mobile: {},
        router_link: '/vendors/pay/',
        table_type: 'vendor transaction',
        search: '',
      }
    };
  },
  props: ['session'],
  beforeMount() {
    this.tokenizer();
    this.getCurrentUser();
    this.init();
  },
  mounted() {
    this.tokenizer();
    this.getCurrentUser();
  },
  methods: {
    tokenizer() {
      const userContext = JSON.parse(localStorage.getItem('loginToken'));
      if (!userContext) {
        this.loggedInUser = {};
        window.location.href = './login';
        // window.location.href = './vendors';
      }
    },
    getCurrentUser() {
      const userContext = JSON.parse(localStorage.getItem('loginToken'));
      if (!userContext) {
        this.loggedInUser = {};
      } else {
        this.loggedInUser = userContext.user_digest;
      }
    },
    init() {
      var self = this;
      
      //if (!this.payerVendors.length) {
        // this.$preloaders.open();
        self.loading = true
        TransactionAPI.methods.getPayerVendors()
        .then(verResponse => {
          // self.$preloaders.close();
          console.log('payerVendors', this.payerVendors);
        })
        .catch(error => {
            console.log('error', error);
        })
        .finally(() => {
          self.loading = false
        })
      //}
    },
    openCNTModal(event) {
      console.log('openCNTModal event', event);
      this.$refs.transactionModal.open();
    }
  },
  computed: {
    payerReceivedTransactionsIsBusy() {
      if (this.axiosRequestAmount == 0) {
        return false;
      }

      return true;
    },
    payerVendorsIsReady () {
      if (this.axiosRequestAmount == 0) {
        return false
      }

      return true
    },
    axiosRequestAmount: {
      get: function () {
        return store.state.axiosRequestAmount;
      },
      set: function (newValue) {
        store.state.axiosRequestAmount = newValue;
      }
    },
    payerVendors: {
      get: function () {
        return store.state.payerVendors;
      },
      set: function (newValue) {
        store.state.payerVendors = newValue;
      }
    },
    rows: {
      get: function() {
        if (!this.filter) {
          return this.payerVendors.length;
        } else {
          return this.masterTableProps.totalRows;
        }
      },
      set: function(newValue) {
        this.masterTableProps.totalRows = newValue;
      } 
    }
  }
};
</script>
<style scoped>
@import '../assets/css/table.css';
.fa-search {
  top: 7px;
  right: 30px;
}
.fa-plus {
  width: 28px;
  height: 28px;
}
.border-2 {
  border-width: 2px;
}
/* body {
  font-weight: 400;
  line-height: normal;
  font-family: Roboto, sans-serif;
  color: #444f60;
} */
</style>
